import { render, staticRenderFns } from "./AulaMultiselect.vue?vue&type=template&id=03931c8e&scoped=true&"
import script from "./AulaMultiselect.vue?vue&type=script&lang=ts&"
export * from "./AulaMultiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03931c8e",
  null
  
)

export default component.exports